import gql from 'graphql-tag';
import { UserFeedFollowGroup } from './group';

export default gql`
  fragment GroupSearchResults on SearchResults {
    count
    results_from
    results {
      ... on Group {
        ...UserFeedFollowGroup
      }
    }
  }
  ${UserFeedFollowGroup}
`;
